import {useTranslation} from 'react-i18next';
import {Button} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import {translations} from '../../../../../../../../i18n/translations';
import {Tooltip} from '../../../../../../../../components/tooltip/tooltip';

type SeniorAttachmentsAddButtonProps = {
  onClick?: () => void;
  disabled?: boolean;
};

export function SeniorAttachmentsAddButton(props: SeniorAttachmentsAddButtonProps) {
  const {t} = useTranslation();

  return (
    <Tooltip.NotAllowedIf
      condition={props.disabled}
      title={t(translations.user_attachments.access_denied.create)}
    >
      <Button
        size="large"
        variant="inverted"
        startIcon={<AddIcon />}
        onClick={props.onClick}
        disabled={props.disabled}
        sx={{
          width: '146px',
          py: '8px',
          textTransform: 'uppercase',
        }}
      >
        {t(translations.seniors.root.add_button)}
      </Button>
    </Tooltip.NotAllowedIf>
  );
}
